import { HashSet2dzve9y63nf0v as HashSet } from './HashSet.mjs';
import { KtMutableSetwuwn7k5m570a as KtMutableSet } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_LinkedHashSet(_this__u8e3s4) {
}
var LinkedHashSetClass;
function LinkedHashSet() {
  if (LinkedHashSetClass === VOID) {
    class $ extends HashSet() {
      static new_kotlin_collections_LinkedHashSet_ahyf7j_k$() {
        var $this = this.new_kotlin_collections_HashSet_ovxcsm_k$();
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static new_kotlin_collections_LinkedHashSet_2u8q9r_k$(elements) {
        var $this = this.new_kotlin_collections_HashSet_4fs03s_k$(elements);
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static new_kotlin_collections_LinkedHashSet_iws7q9_k$(initialCapacity, loadFactor) {
        var $this = this.new_kotlin_collections_HashSet_uopk62_k$(initialCapacity, loadFactor);
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static new_kotlin_collections_LinkedHashSet_wmub5z_k$(initialCapacity) {
        return this.new_kotlin_collections_LinkedHashSet_iws7q9_k$(initialCapacity, 1.0);
      }
      checkIsMutable_jn1ih0_k$() {
        return this.internalMap_1.checkIsMutable_h5js84_k$();
      }
    }
    initMetadataForClass($, 'LinkedHashSet', $.new_kotlin_collections_LinkedHashSet_ahyf7j_k$, VOID, [KtMutableSet()]);
    LinkedHashSetClass = $;
  }
  return LinkedHashSetClass;
}
//region block: exports
export {
  LinkedHashSet as LinkedHashSet2tkztfx86kyx2,
};
//endregion

//# sourceMappingURL=LinkedHashSet.mjs.map
